import { useUserData } from "../../../../../core/router/hooks/useUserData";
import { BrandTextStyle } from "../../../../../core/styles/TextStyles";
import { ProfilePopover } from "./ProfilePopover";

export const Header = () => {
    const [userName] = useUserData();
    return (
        <div className="aevi-header" style={{ zIndex: 1000 }}>
            <div className="aevi-header-left">
                <span className="aevi-header-image" />
                <BrandTextStyle>AP Admin</BrandTextStyle>
            </div>
            <div className="aevi-header-right">
                <div className="aevi-header-username">{userName}</div>
                <ProfilePopover />
            </div>
        </div>
    );
};
